import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';

export default function OpsLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/api/ops/login', { email, password });
      localStorage.setItem('ops_token', response.data.token);
      localStorage.setItem('ops_user', JSON.stringify({
        name: response.data.name,
        email: response.data.email
      }));
      navigate('/ops/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-deep-navy flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-slate-800 rounded-xl shadow-2xl p-8 border border-slate-700">
          <div className="text-center mb-8">
            {/* FMiQ Logo - Official */}
            <svg className="h-12 mx-auto mb-4" viewBox="0 0 180 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="22" width="8" height="22" rx="2" fill="#4A90E2"/>
              <rect x="16" y="8" width="8" height="36" rx="2" fill="#7BB1FF"/>
              <rect x="28" y="16" width="8" height="28" rx="2" fill="#4A90E2"/>
              <path d="M2 46 Q20 38 38 46" stroke="#F5A623" strokeWidth="3" fill="none" strokeLinecap="round"/>
              <text x="48" y="36" fontFamily="Inter, sans-serif" fontSize="30" fontWeight="700" fill="white">
                FM<tspan fill="#F5A623">i</tspan>Q
              </text>
            </svg>
            <h1 className="text-2xl font-inter font-bold text-white">Operations Portal</h1>
            <p className="text-slate-grey font-lato mt-2">Internal Access</p>
          </div>

          {error && (
            <div className="bg-red-500/10 border border-red-500/50 text-red-400 px-4 py-3 rounded-lg mb-6 text-sm font-lato">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-inter font-medium text-slate-300 mb-2">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 bg-slate-700 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary-blue focus:border-transparent font-lato"
                placeholder="you@fmiq.ai"
                required
                data-testid="ops-login-email"
              />
            </div>

            <div>
              <label className="block text-sm font-inter font-medium text-slate-300 mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 bg-slate-700 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary-blue focus:border-transparent font-lato"
                placeholder="••••••••"
                required
                data-testid="ops-login-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 px-4 bg-action-amber hover:bg-accent-600 text-deep-navy font-inter font-semibold rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="ops-login-submit"
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Signing in...
                </span>
              ) : (
                'Sign In'
              )}
            </button>
          </form>
        </div>

        <p className="text-center text-slate-500 text-sm mt-6">
          Internal use only. Unauthorized access is prohibited.
        </p>
      </div>
    </div>
  );
}
